import { useMutation, UseMutationResult } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { InviteUserToDealDto } from '@dealstack/shared/lib/generated';

const inviteDealUser = async ({
	dealId,
	email,
	firstName,
	lastName,
	permissionRoles,
	options,
}: {
	dealId: string;
} & InviteUserToDealDto) => {
	const response = await makeRequest<ApiV1.Response<void>>({
		endpoint: formatUnicorn(API_PATHS.DEAL_DEALID_USERS_POST, {
			dealId,
		}),
		method: HTTP_METHOD.POST,
		body: JSON.stringify({
			email,
			firstName,
			lastName,
			permissionRoles,
			options,
		}),
	});
	return response;
};

export const useInviteDealUser = (): UseMutationResult<
	ApiV1.Response<void>,
	unknown,
	{ dealId: string } & InviteUserToDealDto
> => {
	return useMutation({
		mutationFn: inviteDealUser,
	});
};
